<template>
  <form-wrapper @submit="submit" v-if="!isLoading">
    <organ-requested
      v-if="isOrganAllocation"
      :isDisabled="isDisabled"
      v-model="organ_requested"
    ></organ-requested>
    <Details v-model="details" :isDisabled="isDisabled"></Details>
    <informant-details v-model="informant_details" :isDisabled="isDisabled"></informant-details>
    <treating-physician v-model="treating_physician" :isDisabled="isDisabled"></treating-physician>
    <cause-of-death
      :details="details"
      v-model="cause_of_death"
      :isDisabled="isDisabled"
    ></cause-of-death>
    <previous-admission
      v-model="previous_admission"
      :isDisabled="isDisabled"
    ></previous-admission>
    <apnea-test-details
      v-model="apnea_test_details"
      :isDisabled="isDisabled"
    ></apnea-test-details>
    <donor-contact
      :donor="details"
      v-model="contact"
      :isDisabled="isDisabled"
    ></donor-contact>
    <video-consent-form
      v-if="contact.conset_given == 1"
      v-model="contact"
      :isDisabled="isDisabled"
    ></video-consent-form>
    <media-consent
      v-if="contact.conset_given == 1"
      v-model="contact"
      :isDisabled="isDisabled"
    ></media-consent>
    <witness-details
      v-if="contact.conset_given == 1"
      v-model="contact"
      :isDisabled="isDisabled"
    ></witness-details>
    <consent-attachments
      v-model="consentFiles"
      :filesList="filesList"
      ref="consentAttachments"
      :isDisabled="isDisabled"
      @onFileRemoved="onFileRemoved($event, 'consentAttachments')"
    ></consent-attachments>
    <organ-requested
      v-if="!isOrganAllocation"
      :isDisabled="isDisabled"
      :organAllocation="organ_allocation"
      v-model="organ_requested"
    ></organ-requested>
    <co-morbidities
      v-model="co_morbidities"
      :isDisabled="isDisabled"
      @onCovideChange="covid_free_period = $event"
      :covid_free_period="covid_free_period"
    ></co-morbidities>
    <previous-illnesses v-model="previous_illnesses" :isDisabled="isDisabled"></previous-illnesses>
    <donor-serology v-model="donor_serology" :isDisabled="isDisabled"></donor-serology>
    <injuries v-model="injuries" :isDisabled="isDisabled"></injuries>
    <medical-details v-model="medical_details" :isDisabled="isDisabled">
    </medical-details>
    <ventilator-settings
      v-model="ventilator_settings"
      :isDisabled="isDisabled"
    ></ventilator-settings>
    <APGTest v-model="apg_test" :isDisabled="isDisabled"></APGTest>
    <donor-legal-form
      v-model="formFiles"
      :filesList="filesList"
      ref="formAttachments"
      :isDisabled="isDisabled"
      @onFileRemoved="onFileRemoved($event, 'formAttachments')"
    ></donor-legal-form>
    <resistance-measure
      v-model="resistance_measure"
      :isDisabled="isDisabled"
    ></resistance-measure>
    <medications-inotrope
      v-model="medication_inotrope"
      :isDisabled="isDisabled"
    ></medications-inotrope>
    <donor-lft v-model="donor_lft" :isDisabled="isDisabled"></donor-lft>
    <donor-rft v-model="donor_rft" :isDisabled="isDisabled"></donor-rft>
    <donor-urine v-model="donor_urine" :isDisabled="isDisabled"></donor-urine>
    <donor-cbc v-model="donor_cbc" :isDisabled="isDisabled"></donor-cbc>
    <donor-other-labs v-model="donor_other_labs" :isDisabled="isDisabled"></donor-other-labs>
    <medication
      v-if="false"
      v-model="medications"
      :isDisabled="isDisabled"
    ></medication>
    <attachments
      v-model="files"
      :filesList="filesList"
      ref="attachments"
      :isDisabled="isDisabled"
      @onFileRemoved="onFileRemoved($event, 'attachments')"
    ></attachments>
    <Footer
      v-if="!isOrganAllocation && !isAllocationReport"
      :status="details.status"
      :isDisabled="isDisabled"
      @draft="submit(true)"
    ></Footer>
  </form-wrapper>
</template>

<script>
import Details from "../../components/managedonor/create/Details.vue";
import MedicalDetails from "../../components/managedonor/create/MedicalDetails.vue";
import OrganRequested from "../../components/managedonor/create/OrganRequested.vue";
import Footer from "../../components/managedonor/create/Footer.vue";
import DonorHelper from "../../components/managedonor/donor.helper.js";
import DonorService from "../../assets/services/donor.service";
import { decode } from "../../assets/js/common";
import donorMixins from "../../assets/mixins/donor.mixins";
import Attachments from "../../components/managedonor/create/Attachments.vue";
import DonorContact from "../../components/managedonor/create/DonorContact.vue";
import VentilatorSettings from "../../components/managedonor/create/VentilatorSettings.vue";
import Injuries from "../../components/managedonor/create/Injuries.vue";
import CoMorbidities from "../../components/managedonor/create/CoMorbidities.vue";
import APGTest from "../../components/managedonor/create/APGTest.vue";
import ApneaTestDetails from "../../components/managedonor/create/ApneaTestDetails.vue";
import Medication from "../../components/managedonor/create/Medication.vue";
import CauseOfDeath from "../../components/managedonor/create/CauseOfDeath.vue";
import VideoConsentForm from "../../components/managedonor/create/VideoConsentForm.vue";
import MediaConsent from "../../components/managedonor/create/MediaConsent.vue";
import WitnessDetails from "../../components/managedonor/create/WitnessDetails.vue";
import PreviousAdmission from "../../components/managedonor/create/PreviousAdmission.vue";
import ResistanceMeasure from "../../components/managedonor/create/ResistanceMeasure.vue";
import MedicationsInotrope from "../../components/managedonor/create/MedicationsInotrope.vue";
import ConsentAttachments from "../../components/managedonor/create/ConsentAttachments.vue";
import userHelper from "../../components/manageuser/user.helper";
import DonorLegalForm from "../../components/managedonor/create/DonorLegalForm.vue";
import InformantDetails from "../../components/managedonor/create/InformantDetails.vue";
import TreatingPhysician from "../../components/managedonor/create/TreatingPhysician.vue";
import PreviousIllnesses from "../../components/managedonor/create/PreviousIllnesses.vue";
import DonorSerology from "../../components/managedonor/create/DonorSerology.vue";
import DonorLFT from "../../components/managedonor/create/DonorLFT.vue";
import DonorRFT from "../../components/managedonor/create/DonorRFT.vue";
import DonorUrine from "../../components/managedonor/create/DonorUrine.vue";
import DonorCBC from "../../components/managedonor/create/DonorCBC.vue";
import DonorOtherLabs from "../../components/managedonor/create/DonorOtherLabs.vue";
import menuConstants from "../../assets/constants/menu.constants";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    Details,
    OrganRequested,
    MedicalDetails,
    Footer,
    Attachments,
    DonorContact,
    VentilatorSettings,
    Injuries,
    CoMorbidities,
    APGTest,
    ApneaTestDetails,
    Medication,
    CauseOfDeath,
    VideoConsentForm,
    MediaConsent,
    WitnessDetails,
    PreviousAdmission,
    ResistanceMeasure,
    MedicationsInotrope,
    ConsentAttachments,
    DonorLegalForm,
    InformantDetails,
    TreatingPhysician,
    PreviousIllnesses,
    DonorSerology,
    "donor-lft": DonorLFT,
    "donor-rft": DonorRFT,
    "donor-urine": DonorUrine,
    "donor-cbc": DonorCBC,
    "donor-other-labs": DonorOtherLabs,
  },
  data() {
    return {
      contacts: [],
      files: [],
      consentFiles: [],
      formFiles: [],
      filesList: [],
      isLoading: true,
      covid_free_period: "",
      organ_requested: {},
      organ_allocation: [],
      details: {
        donor_name: "",
        organ_harvesting_date: "",
        age: "",
        DOB: "",
        sex: "",
        blood_group: "",
        height: "",
        weight: "",
        BMI: "",
        medical_legal_case: "",
        MLC_AR_No: "",
        mlc_police_mail: "",
        mlc_police_phone: "",
        mlc_nodal_officer_mail: "",
        mlc_nodal_officer_phone: "",
        mlc_hod_forensic_mail: "",
        mlc_hod_forensic_phone: "",
        notto_id: "",
        status: 8,
        created_by: "",
        dml_indicator: "I",
        hospital_id: "",
        individual_id: "",
        donor_temp_registration_id: "",
      },
      informant_details: {
        informant_name: "",
        informant_designation: "",
        informant_phone: "",
        information_datetime: "",
      },
      treating_physician: {
        treating_physician_name: "",
        treating_physician_contact: "",
      },
      cause_of_death: {
        cause_of_death_id: "",
        cause_of_death_notes: "",
        date_of_admisssion: "",
        date_of_accident: "",
        No_of_days_ventilator: "",
        tentative_retreival_date: "",
        assessment_datetime: "",
        case_summary_document: null,
        reason_for_hospitalisation: "",
        date_of_ventilation: "",
        days_in_icu: "",
      },
      previous_admission: {
        shifted_from_hospital: "",
        shifted_hospital_document: null,
        previous_admission_hospital: "",
        previous_admission_date: "",
        previous_admission_details: "",
      },
      contact: {
        first_name: "",
        last_name: "",
        email_id: "",
        country_code_1: "",
        phone_number_1: "",
        country_code_2: "",
        phone_number_2: "",
        contact_id: "",
        type_of_consent: "",
        conset_given: "",
        type_of_consent_upload: "",
        consent_id_proof: null,
        media_consent_document: null,
        // Phase 2 - Video Consent & Witness Details
        video_consent_document: null,
        video_consent_date: "",
        video_consent_status: "",
        witness_name: "",
        witness_id_document: null,
        witness_contact: "",
        // Phase 2 - Additional Video Consent fields
        media_consent_given: "",
        media_consent_details: "",
        media_contact_person: "",
        media_contact_number: "",
        consent_remarks: "",
        witness_relation: "",
        witness_address: "",
        witness_2_name: "",
        witness_2_id_document: null,
        witness_2_contact: "",
        witness_2_relation: "",
        witness_2_address: "",
      },
      medical_details: {
        pulse_rate: "",
        systolic: "",
        diastolic: "",
        MAP: "",
        CVP: "",
        urine_output: "",
        urine_unit: 1,
        SPO2: "",
        temperature: "",
      },
      ventilator_settings: {
        ventilation: "",
        FIO2: "",
        PEEP: "",
        PIP: "",
        TV: "",
        RR: "",
        pressure_support: "",
        VCV: "",
        PCV: "",
        others: "",
      },
      injuries: {
        chest_injuries: "",
        abdomen_injuries: "",
        notes: "",
      },
      resistance_measure: {
        CPR_given: "",
        CPR_notes: "",
        hypotensive_episodes: "",
      },
      co_morbidities: {},
      apg_test: {
        ABG_file_upload_1: "",
        ABG_file_upload_2: "",
        ABG_file_upload_3: "",
        ABG_file_upload_4: "",
        FIO2_1: "",
        FIO2_2: "",
        FIO2_3: "",
        FIO2_4: "",
        abg_ph_1: "", abg_paco2_1: "", abg_pao2_1: "", abg_hco3_1: "",
        abg_ph_2: "", abg_paco2_2: "", abg_pao2_2: "", abg_hco3_2: "",
        abg_ph_3: "", abg_paco2_3: "", abg_pao2_3: "", abg_hco3_3: "",
        abg_ph_4: "", abg_paco2_4: "", abg_pao2_4: "", abg_hco3_4: "",
      },
      previous_illnesses: {
        thyroid_status: "",
        long_term_medications: "",
        previous_surgeries: "",
      },
      donor_serology: {
        syphilis_serology: "",
        anti_hbc_total: "",
      },
      donor_lft: {
        lft_total_bilirubin: "", lft_direct_bilirubin: "", lft_indirect_bilirubin: "",
        lft_sgot: "", lft_sgpt: "", lft_total_protein: "", lft_albumin: "",
        lft_globulin: "", lft_ag_ratio: "", lft_alp: "", lft_ggt: "",
        lft_inr: "", lft_ldh: "",
      },
      donor_rft: {
        rft_sodium: "", rft_potassium: "", rft_chloride: "",
        rft_phosphorous: "", rft_magnesium: "", rft_calcium: "",
        rft_bun: "", rft_urea: "", rft_creatinine: "",
      },
      donor_urine: {
        urine_albumin: "", urine_rbc: "", urine_pus_cells: "",
        upcr_protein: "", upcr_creatinine: "",
      },
      donor_cbc: {
        cbc_haemoglobin: "", cbc_mcv: "", cbc_mch: "", cbc_mchc: "",
        cbc_platelet_count: "", cbc_haematocrit: "", cbc_total_wbc: "",
      },
      donor_other_labs: {
        core_antigen_total: "", random_blood_sugar: "",
        amylase: "", lipase: "",
        procalcitonin: "", crp: "",
        covid_rtpcr_result: "",
      },
      medication_inotrope: {
        inotrope_1: "",
        inotrope_2: "",
        inotrope_3: "",
        inotrope_4: "",
        harmone_replacement_theraphy: "",
        steroids: "",
        vasopressin: "",
        thyroxine: "",
      },
      apnea_test_details: {
        brain_death_confirmation_type: "",
        first_apnea_date: "",
        first_apnea_status: "",
        first_apnea_file_upload_1: null,
        first_apnea_file_upload_2: null,
        second_apnea_date: "",
        second_apnea_status: "",
        second_apnea_file_upload_1: "",
        second_apnea_file_upload_2: "",
        ct_angiography_document: null,
        bd_doctor_1_id: "",
        bd_doctor_2_id: "",
        bd_doctor_3_name: "",
        bd_doctor_3_designation: "",
        bd_doctor_4_name: "",
        bd_doctor_4_designation: "",
      },
      medications: [],
      updateDoc: {},
    };
  },
  mixins: [donorMixins],
  computed: {
    isDisabled() {
      if (this.isOrganAllocation || this.isAllocationReport) return true;
      let hasEditAccess = this.hasEditAccess(menuConstants.MANAGE_DONOR);
      let statusList = [2, 9, 7];
      return !hasEditAccess || statusList.indexOf(this.details.status) != -1;
    },
    isAadharNotPermanent() {
      return this.aadhar_address.is_permanent_address == "0";
    },
  },
  methods: {
    onFileRemoved(id, ref) {
      const vm = this;
      let list = vm.filesList.filter((item) => {
        return item.donor_investigations_fileupload_mapping_id != id;
      });
      vm.filesList = list;
      setTimeout(() => {
        vm.$refs[ref].init();
      }, 500);
    },
    isParameter(id) {
      return this.organ_requested.organ_id.indexOf(id) != -1;
    },
    async submit(isDraft) {
      const vm = this;
      let reviewStatus = [3, 4];
      try {
        let doc = DonorHelper.getDoc(vm);
        if (!isDraft) {
          if (doc.status == 8) {
            doc.status = 1;
          }
          if (reviewStatus.indexOf(doc.status) != -1) {
            doc.status = 5;
          }
          if (doc.conset_given == 0) {
            doc.status = 7;
          }
        }
        let details = [];
        Object.keys(doc).forEach((key) => {
          details.push({ key, value: doc[key] });
        });
        if (isDraft) {
          let draftFields = {
            blood_group: "Blood Group",
            cause_of_death_id: "Cause of Brain Death",
            contact_id: "Donor Relationship",
          };
          let list = [];
          Object.keys(draftFields).forEach((key) => {
            if (!doc[key]) {
              list.push(draftFields[key]);
            }
          });
          if (list.length > 0) {
            console.log(list);
            vm.$alert.show(
              `Please update the following fields to save as draft <b>${list.toString()}</b>`
            );
            return;
          }
        }
        vm.$loader.show();

        for (let item of details) {
          let { key, value } = item;
          if (value instanceof File) {
            if (value.type && value.type.startsWith("video/")) {
              doc[key] = await userHelper.uploadVideo(value);
            } else {
              doc[key] = await userHelper.uploadContact(value);
            }
          } else {
            doc[key] = value;
          }
        }

        let { data } = await DonorService.create(doc);
        let { msg, status, donor_temp_registration_id } = data;
        if (status == false) {
          vm.$alert.show(msg);
          vm.$loader.hide();
          return;
        }
        let files = vm.files.concat(vm.consentFiles);
        files = files.concat(vm.formFiles);
        for (let item of files) {
          if (item.file !== null) {
            await DonorHelper.upload(item, donor_temp_registration_id, vm);
          }
        }
        if (vm.isUpdate) {
          vm.$alert.show("Donor Updated successfully");
        } else {
          vm.$alert.show("Donor created successfully");
        }
        vm.$router.push("/manage-donor");
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    init() {
      const vm = this;
      let { created_by } = vm;
      vm.details.created_by = created_by;
      if (vm.isCreate) {
        vm.details.hospital_id = decode(vm.$route.query.hospital_id);
      }
      if (vm.isUpdate) {
        DonorHelper.getRecipient(vm);
      } else {
        vm.isLoading = false;
      }
      // window.$("form").each(function () {
      //   console.log(window.$(this).find(":input"));
      // });
    },
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
};
</script>

<style></style>
